import React  from 'react'
import { Link} from 'react-router-dom';
import '../login page/hom1/style.css'
import '../login page/hom1/Dry-Fruit.css'
const Payment = () => {
    return(
        <button className="wbtn123 wbtn1123 wishlistb "><Link to={{ pathname:"https://rzp.io/l/VmjWhGd"}} target="_blank">PAYMENT</Link></button> 
    )
}
export default Payment;